// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetAnnouncementsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AnnouncementDTO from '../models/AnnouncementDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    userId: string | null;
    includeShown: boolean;
    fetchAmount: number;
    loadedAmount: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            userId: '00000000-0000-0000-0000-000000000000',
            includeShown: false,
            fetchAmount: 0,
            loadedAmount: 0,
        },
        initValues);
    },
    userId: 'userId',
    includeShown: 'includeShown',
    fetchAmount: 'fetchAmount',
    loadedAmount: 'loadedAmount',
}

interface Result extends ResultDTO {
    announcement: AnnouncementDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            announcement: [],
        },
        initValues);
    },
    announcement: 'announcement',
}

export { Request, Result };